import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { DepositReachedThresholdPopup } from './DepositReachedThresholdPopup';

export const depositReachedThresholdPopupAction = () => addPopupAction({
    isModal: true,
    component: DepositReachedThresholdPopup,
    layer: LAYER.ADVANCED_PLAYER_MESSAGE_MODAL
});
